export enum ReservationQuestionType {
    Text = 0,
    PersonalID,
    Email,
    PhoneNumber,
    FirstName,
    LastName,
    Client,
    Case
}